import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'ui-framework'

export interface WhyNoSirProps {
  link?: string
  action?: (arg: any) => void
  text: string
  buttonText?: string
}

export function WhyNoSir(props: WhyNoSirProps) {
  const imageHeight = 258
  const txtSize = 'txt-size-2'

  return (
    <div className="flex-col items-center justify-center margin-bottom-2">
      <div className={`txt-color-alternate margin-top-1 txt-center ${txtSize}`}>{props.text}</div>
      <div className="margin-v-2 flex-center">
        <img src="/images/no-trading-or-lending.svg" height={imageHeight} />
      </div>
      {props.link && (
        <Link to={props.link} className="btn btn--blue btn--medium btn--responsive">
          {props.buttonText}
        </Link>
      )}
      {props.action && (
        <Button
          variant="blue"
          className="btn--responsive"
          name="no-open-positions"
          onClick={props.action}>
          {props.buttonText}
        </Button>
      )}
    </div>
  )
}

export default WhyNoSir
